export default {
  english: {
    signIn: 'Sign in in order to bookmark the article',
    mark: 'Add to favorites',
    unmark: 'Remove from favorites',
  },
  french: {
    signIn: 'Connectez-vous pour ajouter l\'article à vos favoris',
    mark: 'Ajouter aux favoris',
    unmark: 'Supprimer des favoris',
  },
  arabic: {
    signIn: 'قم بتسجيل الدخول لوضع إشارة مرجعية على المقالة',
    mark: 'اضافة الى المفضلة',
    unmark: 'إزالة من المفضلة',
  },
  hebrew: {
    signIn: 'פתח את עמוד ההתחברות',
    mark: 'הוסף למועדפים',
    unmark: 'הסר ממועדפים',
  },
  persian: {
    signIn: 'برای نشانک گذاری مقاله وارد سیستم شوید',
    mark: 'به علاقه مندی ها اضافه کنید',
    unmark: 'حذف از موارد دلخواه',
  },
}
